import { ScrollView, View, Text, Pressable, TouchableOpacity, useWindowDimensions, Platform } from 'react-native';
import GridBackground from './GridPattern';
import { forwardRef, useCallback, useEffect, useState } from "react";
import { FlatList } from "react-native";
import moment from 'moment';
import React from 'react';
import * as Animatable from 'react-native-animatable';
import { FontAwesome5 } from '@expo/vector-icons';
import * as SVG from 'react-native-svg';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import RenderWP from './RenderWP';
import { DefaultRootState } from '@reduxLocal/persistState';
import { useSelector } from 'react-redux';

interface ProjectGanttProps {
  users: any[],
  taskList: any[],
  projectStart: Date,
  projectEnd: Date,
  highlightedItem?: Number,
  setHighlightedItem?: Function
}


const ProjectGantt = forwardRef<ScrollView, ProjectGanttProps>((props, ref) => {
  const { users, taskList, projectStart, projectEnd, highlightedItem } = props;
  const [chartWidth, setChartWidth] = useState(0);
  const [chartHeight, setChartHeight] = useState(0);
  const [data, setData] = useState(taskList);
  const [itemWidth, setItemWidth] = useState(0);
  const projectRange = moment(projectEnd).unix() - moment(projectStart).unix();
  const theme = themeSelector();
  const globalDate = useSelector((state: DefaultRootState) => state.UI.dateFormat);



  function calculateMarkerOffset() {
    const projectStartDate = moment().unix() - moment(projectStart).unix();
    return `${(projectStartDate * 100) / projectRange}%`
  }



  const generateMonthArray = () => {
    const monthArray = [];
    const startMonth = moment(projectStart).month();
    const endMonth = moment(projectEnd).month();

    for (let i = startMonth; i < endMonth + 1; i++) {
      monthArray.push(`${moment().month(i).format('MMMM')}`)
    }

    return (
      <>
        {
          monthArray.map(item => {
            return (
              <View key={item} style={{ padding: 10, flex: 1, borderBottomEndRadius: 40, borderBottomStartRadius: 40, backgroundColor: '#ececec', shadowRadius: 5, shadowOpacity: .2 }}>
                <Text style={{ fontWeight: "bold", textAlign: 'center' }}>{item}</Text>
              </View>
            )
          })
        }
      </>
    )
  }

  const Marker = () => {
    return (
      <Animatable.View transition={'left'} style={{ position: 'absolute', height: chartHeight + 32, top: 30, zIndex: -1, overflow: 'visible', left: calculateMarkerOffset(), zIndex: 10 }}>
        <FontAwesome5 name="map-marker" size={24} color="rgb(90,192,234)" style={{left: -.1}} />
        <SVG.Svg width={2} height={chartHeight + 90} style={{ marginLeft: 7.88, overflow: "hidden" }} >
          <SVG.Rect id={'Somenewid'} width={2} fill={'rgb(90,192,234)'} strokeDasharray={[10]} height={Platform.OS === 'web' ? "100%" : "70%"} strokeWidth={2} />
        </SVG.Svg>
      </Animatable.View>
    )
  }

  return (
    <View style={{ flexDirection: 'row', overflow: "hidden", paddingVertical: 10, flex: 1, margin: -30 }} >
      {
        Platform.OS === 'web' &&
        <Text style={{ flex: .1, alignSelf: 'center', justifyContent: 'center', padding: 20, height: 70, maxHeight: 100, minWidth: 300, marginHorizontal: -100, maxWidth: 351, borderRadius: 20, borderTopStartRadius: 0, borderTopEndRadius: 0, color: 'white', backgroundColor: 'rgb(90,192,234)', transform: [{ rotateZ: '-90deg' }] }}>PROJECT START DATE: {'\n'}<Text style={{ fontWeight: '600', fontSize: 18 }}>{moment(projectStart).format(globalDate)}</Text></Text>
      }
      <View style={{ flex: 5, borderRadius: 20, overflow: "hidden" }}>
        <View style={{ minHeight: 50, overflow: 'visible', zIndex: 4, top: -30, maxHeight: Platform.OS === 'web' ? '90%' : "40%" }}>
          {
            moment(Date.now()) >= moment(projectStart) && moment(Date.now()) <= moment(projectEnd) &&
            <Marker />
          }
        </View>
        <View style={{ flex: 1, top: -20 }}>
          <ScrollView scrollEnabled={false} style={{ flex: 10, zIndex: 1 }} contentContainerStyle={{ flexGrow: 1 }} onLayout={({ nativeEvent }) => { setChartWidth(nativeEvent.layout.width); setChartHeight(nativeEvent.layout.height) }} showsHorizontalScrollIndicator showsVerticalScrollIndicator={false}>
            <View style={{ flex: 1, overflow: "visible" }}>
              <View style={{ flexDirection: 'row', left: Platform.OS === 'web' ? -30 : undefined, transform: [{ scale: 0.6 }] }}>
                {
                  Platform.OS !='android' &&
                <GridBackground theme={theme} projectStart={projectStart} projectEnd={projectEnd} width={chartWidth} height={chartHeight / 3} />
                }
              </View>
              <View style={{ flex: 1, zIndex: 3, minWidth: '100%', paddingBottom: 5, marginBottom: 5 }}>
                <FlatList
                  data={taskList}
                  extraData={taskList}
                  CellRendererComponent={({ children, index, style, ...props }) => {
                    const isHighlighted = highlightedItem === index;
                    const newStyle = [style, { zIndex: 2, borderRadius: 10}];
                    return <Animatable.View transition={['borderWidth']} style={[newStyle, { borderWidth: isHighlighted ? 2 : 0, borderColor: 'rgb(90,192,234)', }]} {...props}>{children}</Animatable.View>
                  }}
                  renderItem={({ item, index }) => <RenderWP ref={ref} containerWidth={chartWidth - 150} projectRange={projectRange} projectStart={projectStart} projectEnd={projectEnd} chartHeight={chartHeight - 30} taskList={taskList.length} item={item} index={index} />}
                  ListEmptyComponent={() => (<Text style={{ padding: 100 }}>No Work Packages to show</Text>)}
                  showsHorizontalScrollIndicator={true}
                  style={{ overflow: 'visible', flex: 1, minWidth: '100%' }}
                  contentContainerStyle={{ minWidth: chartWidth, overflow: 'visible', gap: 3 }}
                  keyExtractor={(item) => item._id} />
              </View>
            </View>
          </ScrollView>
          <View style={{ flex: 1, zIndex: -3, flexDirection: 'row', backgroundColor: 'transparent', maxHeight: Platform.OS === 'web' ? 70 : 35, alignSelf: 'stretch', top: 0, overflow: 'visible' }}>
            {
              generateMonthArray()
            }
          </View>
        </View>
      </View>
      {
        Platform.OS === 'web' &&
        <Text style={{ overflow: 'visible', alignSelf: 'center', justifyContent: 'center', padding: 20, height: 70, maxHeight: 100, minWidth: 300, marginHorizontal: -100, maxWidth: 351, borderRadius: 20, color: 'white', backgroundColor: 'rgb(90,192,234)', transform: [{ rotateZ: '-90deg' }] }}>PROJECT END DATE: {'\n'}<Text style={{ fontWeight: '600', fontSize: 18 }}>{moment(projectEnd).format(globalDate)}</Text></Text>
      }
    </View >
  )
})
export default ProjectGantt;

